import { Search, Network, Palette, Code2, ShieldCheck, Rocket, Check, Loader2, Minus, AlertTriangle } from "lucide-react";

export const AGENT_META = {
  analyst: { name: "Analista", icon: Search },
  architect: { name: "Arquitecto", icon: Network },
  designer: { name: "Diseñador", icon: Palette },
  programmer: { name: "Programador", icon: Code2 },
  verifier: { name: "Verificador", icon: ShieldCheck },
  publisher: { name: "Publicador", icon: Rocket },
};

const ORDER = ["analyst", "architect", "designer", "programmer", "verifier"];

function StateIcon({ st }) {
  if (st?.status === "running") return <Loader2 className="w-3.5 h-3.5 animate-spin text-cyan-400" />;
  if (st?.status === "skipped") return <Minus className="w-3.5 h-3.5 text-slate-500" />;
  if (st?.status === "done" && st.output?.passed === false) return <AlertTriangle className="w-3.5 h-3.5 text-amber-400" />;
  if (st?.status === "done") return <Check className="w-3.5 h-3.5 text-emerald-400" />;
  return <span className="w-1.5 h-1.5 rounded-full bg-slate-600" />;
}

export function AgentPipeline({ state, chars }) {
  return (
    <div className="rounded-xl border border-blue-500/30 bg-[#0c1220] p-3 space-y-1.5" data-testid="agent-pipeline">
      <p className="text-[10px] uppercase tracking-[0.2em] text-cyan-400 font-semibold mb-2">Coordinador multiagente</p>
      {ORDER.map((id) => {
        const st = state[id];
        const M = AGENT_META[id];
        return (
          <div key={id} className={`flex items-center gap-2.5 text-xs ${st ? "text-slate-200" : "text-slate-500"}`} data-testid={`pipeline-agent-${id}`} data-status={st?.status || "pending"}>
            <M.icon className="w-3.5 h-3.5" />
            <span className="flex-1">{M.name}{st?.attempt > 1 ? ` · intento ${st.attempt}` : ""}</span>
            {id === "programmer" && st?.status === "running" && <span className="font-mono text-[10px] text-slate-400">{chars} car.</span>}
            {st?.status === "skipped" && <span className="text-[10px] text-slate-500">omitido</span>}
            <StateIcon st={st} />
          </div>
        );
      })}
      {state.programmer?.status === "running" && (
        <div className="relative h-0.5 mt-2 overflow-hidden rounded bg-white/5"><div className="absolute inset-y-0 w-1/3 bg-gradient-to-r from-transparent via-cyan-400 to-transparent scan-bar" /></div>
      )}
    </div>
  );
}

export function AgentsRun({ list }) {
  const uniq = [...new Set(list || [])];
  if (!uniq.length) return null;
  return (
    <div className="flex flex-wrap gap-1 mt-2">
      {uniq.map((a) => {
        const M = AGENT_META[a];
        return M ? <span key={a} className="inline-flex items-center gap-1 text-[10px] px-1.5 py-0.5 rounded border border-[#222B40] text-slate-400"><M.icon className="w-3 h-3" />{M.name}</span> : null;
      })}
    </div>
  );
}
